import React from "react";
import { RenderForm } from "../../utils/formUtils";
import useForm from "../../hooks/useForm";
import { useTicketsForm } from "../../hooks/tickets/useTicketsForm";
import styled from "styled-components";
import { Stack } from "@mui/material";
import { FormButton } from "../../components/buttons/FormButton";
import { Divider } from "antd";
import { PENDING } from "../../constants/webapp";
import { secondaryColor } from "../../theme/Theme";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { TICKETS_API } from "../../constants/api";
import { Timestamp } from "firebase/firestore";
import { useUpload } from "../../hooks/useUpload";
import { LogoView } from "../../components/elements/LogoView";

const contactData = [
  {
    title: "Email Us",
    subtitle: "eight8ug@gmail.com",
  },
  {
    title: "Customer Support",
    subtitle: "+(256) 702 353 857",
  },
];

export const ClientTicketForm = () => {
  const { form, updateFormValues, onChange, clearForm } = useForm({
    // description: "Test",
    // email: "reypak.sweg@gmail.com",
    priority: 2,
    // topic: "Product Delivery",
  });
  const { loading, setDocData: addTicket } = useFirebase();
  const {
    imageUrls: uploadedUrls,
    uploadImages,
    loading: uploading,
  } = useUpload();
  const { formFields } = useTicketsForm();

  // console.log(form);

  function getUrl(subtitle) {
    if (subtitle.includes("@")) return `mailto:${subtitle}`;
    return `tel:${subtitle}`;
  }

  function createNewTicket() {
    let ticket_id = Date.now().toString();
    // update form
    delete form.images;
    form.imageUrls = uploadedUrls;
    form.timestamp = Timestamp.now();
    form.status = PENDING;
    addTicket(TICKETS_API, ticket_id, form, clearForm);
  }

  const onSubmit = (e) => {
    e.preventDefault();

    if (form?.images?.length > 0)
      return uploadImages(form.images, "tickets", createNewTicket);

    createNewTicket();
  };

  return (
    <div className="flexCenter">
      <Wrapper className="">
        <LogoView />
        <GridWrapper>
          {/* Left */}
          <form onSubmit={onSubmit}>
            <FormWrapper>
              <Stack spacing={3}>
                <RenderForm
                  form={form}
                  onChange={onChange}
                  fields={formFields}
                  updateFormValues={updateFormValues}
                />
                <FormButton loading={loading || uploading}>
                  Submit Ticket
                </FormButton>
              </Stack>
            </FormWrapper>
          </form>

          {/* Right */}
          <Stack spacing={3}>
            <h3>Get In Touch</h3>
            {/* <Divider /> */}
            {contactData.map(({ title, subtitle }) => (
              <>
                <Divider />
                <div style={{ lineHeight: 2 }}>
                  <p
                    className="lightColor font12"
                    style={{ textTransform: "uppercase" }}
                  >
                    {title}
                  </p>
                  <a
                    href={getUrl(subtitle)}
                    style={{ textDecoration: "none", color: secondaryColor }}
                  >
                    <b>{subtitle}</b>
                  </a>
                </div>
              </>
            ))}
          </Stack>
        </GridWrapper>
      </Wrapper>
    </div>
  );
};

export const Wrapper = styled.div`
  padding: 20px;
  width: 50%;

  @media (max-width: 860px) {
    width: 100%;
    // padding: 20px;
  }
`;
export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 50px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;
export const FormWrapper = styled.div``;
